import ProductNoteModal from './ProductNoteModal';

export default ProductNoteModal;
